'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Module Dependencies.
 */
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var bindAll = require('bind-all');
/**
 * HOP.
 */
var has = Object.prototype.hasOwnProperty;
/**
 * Expose `Memory`
 */
module.exports = bindAll(new Memory());
/**
 * Initialize `Memory` store
 */
function Memory() {
    this.store = {};
}
/**
 * Set a `key` and `value`.
 */
Memory.prototype.set = function (key, value) {
    this.store[key] = lodash_clonedeep_1.default(value);
    return true;
};
/**
 * Get a `key`.
 */
Memory.prototype.get = function (key) {
    if (!has.call(this.store, key))
        return;
    return lodash_clonedeep_1.default(this.store[key]);
};
/**
 * Remove a `key`.
 */
Memory.prototype.remove = function (key) {
    delete this.store[key];
    return true;
};



//////////////////
// WEBPACK FOOTER
// ./~/@segment/analytics.js-core/build/memory.js
// module id = 393
// module chunks = 0